module.exports = __webpack_public_path__ + "static/logo-communitycinemas-844165a2d7031aa784ae5f0c39f2f2ce.png";